import { useTranslator } from '@bluebeam/react-i18n';
import { Button } from 'components/lib';
import { ModalStaticProperties } from 'components/ModalPortal/ModalPortal';
import ModalStdHeader from 'components/modals/ModalStdHeader';
import {
  MapOverlayMachineEventsEnum,
  useMapOverlayMachine,
} from 'components/Overlays/MapOverlayMachine';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { PostRFI } from 'records/interactions/PostRFI';
import { RFI } from 'records/RFI';
import '../modals.css';
import PostRFIList from './PostRFIList';

interface Props {
  sheetid: string;
  pageid: string;
}

const PostRFISelectModal: React.FC<Props> & ModalStaticProperties = ({
  sheetid,
  pageid,
}) => {
  const { actions } = useContext(AppStoreContext);
  const [selectedRFI, setSelectedRFI] = useState<RFI | null>(null);
  const { mapOverlayMachineService } = useMapOverlayMachine();
  const location = useLocation();
  const { translate } = useTranslator(['mapView', 'buttons']);

  const handleCancelClick = (): void => {
    actions.clearAllModals();
  };

  const handleSelectRFIClick = (): void => {
    if (selectedRFI !== null) {
      actions.createInteraction(
        new PostRFI({
          rfi: selectedRFI,
          sheetid,
          pageid,
        })
      );

      actions.clearAllModals();

      // Close Layers and View RFI overlays.
      if (location.pathname.includes('map')) {
        mapOverlayMachineService.send(
          MapOverlayMachineEventsEnum.CLOSE_OVERLAY
        );
      } else {
        actions.deleteInteractions('ViewMapLayers');
        actions.deleteInteractions('ViewRFI');
      }
    }
  };

  return (
    <div
      id="post-rfi-select-modal"
      className="modal__content"
      style={{ height: '84vh' }}
    >
      <ModalStdHeader
        text={translate('mapView:postRFISelectModal.selectRFI')}
      />
      <div className="h100 pt7 pb6">
        <div className="h100 column mt5">
          <div className="mx4">
            <div className="font-size-7 black-2 mb2">
              {translate('mapView:postRFISelectModal.selectRFI')}
            </div>
            <div className="font-size-5 light mb4">
              {translate('mapView:postRFISelectModal.selectRFIText')}
            </div>
            <div className="bb-2 mb4" />
          </div>
          <PostRFIList onRFIClick={setSelectedRFI} selectedRFI={selectedRFI} />
          <div className="row shrink-0 justify-between px4 py3 bt-2">
            <Button
              id="map-rfi-create-cancel"
              variant="tertiary"
              size="large"
              onClick={handleCancelClick}
            >
              {translate('buttons:cancel')}
            </Button>
            <Button
              id="map-rfi-create-select"
              variant="primary"
              size="large"
              disabled={selectedRFI === null}
              onClick={handleSelectRFIClick}
            >
              {translate('buttons:select')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

PostRFISelectModal.modalClasses = {
  overlay: `modal__overlay`,
  content: `modal__window modal--sm`,
};

PostRFISelectModal.modalStyles = {
  content: {
    width: '628px',
  },
};

export default PostRFISelectModal;
